import {
  ComponentRef,
  Directive,
  EnvironmentInjector,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  Type,
  ViewContainerRef,
} from '@angular/core';

@Directive({
  selector: '[appTableDynamicCell]',
})
export class TableDynamicCellDirective implements OnChanges, OnDestroy {
  @Input('appTableDynamicCell') component?: Type<unknown>;
  @Input('appTableDynamicCellInputs') inputs?: Record<string, any>;

  private componentRef?: ComponentRef<unknown>;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private environmentInjector: EnvironmentInjector
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['component']) {
      this.renderComponent();
    }

    if (changes['inputs'] && this.componentRef) {
      this.assignInputs();
    }
  }

  private renderComponent(): void {
    this.viewContainerRef.clear();
    this.componentRef?.destroy();
    this.componentRef = undefined;

    if (!this.component) {
      return;
    }

    this.componentRef = this.viewContainerRef.createComponent(this.component, {
      environmentInjector: this.environmentInjector,
    });

    this.assignInputs();
  }

  private assignInputs(): void {
    if (!this.componentRef || !this.inputs) {
      return;
    }

    Object.entries(this.inputs).forEach(([key, value]) => {
      (this.componentRef!.instance as Record<string, any>)[key] = value;
    });

    this.componentRef.changeDetectorRef.markForCheck();
    this.componentRef.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.componentRef?.destroy();
  }
}
